import { Link, useNavigate } from 'react-router-dom';
import { useCookieConsent } from '@/context/CookieConsentContext';
import { motion } from 'framer-motion';
import { CookieIcon, ShieldCheckIcon } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export default function CookieConsent() {
  const { hasConsent, setConsent } = useCookieConsent();
  const { user } = useAuth();
  const navigate = useNavigate();

  if (hasConsent) {
    return null;
  }

  const handleAccept = () => {
    setConsent(true);
    
    // If user is logged in, redirect to dashboard
    if (user) {
      navigate('/dashboard', { replace: true });
    }
  };

  return (
    <>
      {/* Overlay to prevent scrolling and interaction */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-40" />

      {/* Cookie consent banner */}
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 p-6"
      >
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex-1 space-y-4">
              <div className="flex items-center space-x-2 text-gray-900">
                <CookieIcon className="h-6 w-6" />
                <h2 className="text-xl font-semibold">Cookie Consent</h2>
              </div>

              <div className="prose prose-sm max-w-none text-gray-600">
                <p>
                  We use cookies and similar technologies to analyze website traffic and improve your experience. 
                  By clicking "Accept All Cookies", you consent to the use of Google Analytics for these purposes.
                </p>
                <div className="flex items-start space-x-2 text-sm mt-2">
                  <ShieldCheckIcon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                  <p className="text-gray-500">
                    Your data is processed in accordance with our{' '}
                    <Link to="/privacy" className="text-primary-600 hover:text-primary-700 font-medium">
                      Privacy Policy
                    </Link>{' '}
                    and{' '}
                    <Link to="/cookies" className="text-primary-600 hover:text-primary-700 font-medium">
                      Cookie Policy
                    </Link>.
                  </p>
                </div>
              </div>
            </div>

            <div className="w-full md:w-auto">
              <button
                onClick={handleAccept}
                className="w-full md:w-auto px-8 py-3 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors"
              >
                Accept All Cookies
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}